import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '../../shared/button.component';
import Select from '../../shared/reactSelect/select.component';

import PasteCreatable from '../../shared/reactSelect/pasteCreatable.component';
import { singleAssignmentPropTypes } from '../../shared/propTypes/userClients';
import { ALL_ASSIGNMENTS_CODE } from '../constants';

class AssignmentsSelect extends PureComponent {
  static propTypes = {
    currentAssignmentsRowData: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      assignmentType: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })),
    checkedAssignmentsMap: PropTypes.objectOf(PropTypes.objectOf(singleAssignmentPropTypes)).isRequired,
    selectAssignments: PropTypes.func.isRequired,
  };

  state = {
    selectedAssignments: [],
  };

  selectAssignment = selectedAssignments => {
    const assignmentsToSelect = this.props.currentAssignmentsRowData.filter(
      ({ value }) => selectedAssignments.some(
        selectedAssignment => selectedAssignment.value.toLowerCase() === value.toLowerCase()
      )
    );
    this.setState({
      selectedAssignments: assignmentsToSelect,
    });
  };

  submitAssignments = () => {
    this.props.selectAssignments(this.state.selectedAssignments);
    this.setState({
      selectedAssignments: [],
    });
  };

  render() {
    const {
      currentAssignmentsRowData,
      checkedAssignmentsMap,
    } = this.props;

    const {
      selectedAssignments,
    } = this.state;

    const filteredOptions = currentAssignmentsRowData.filter(
      ({ assignmentTypeCode, value }) =>
        !(checkedAssignmentsMap?.[assignmentTypeCode]?.[value]) && value !== ALL_ASSIGNMENTS_CODE
    );

    return (
      <div className="assignments-select row a-my-10">
        <div className="col-xs-12 col-md-10">
          <Select
            className="form-control"
            multi
            options={filteredOptions}
            onChange={this.selectAssignment}
            scrollMenuIntoView={false}
            placeholder="Add Businesses, Countries, Connections, LEs, BUs, or Company Codes (separate with comma)"
            value={selectedAssignments}
            virtualized
            selectComponent={PasteCreatable}
          />
        </div>
        <div className="col-xs-12 col-md-2">
          <Button
            type="button"
            kind="primary"
            size="lg"
            onClick={this.submitAssignments}
          >
            Add Assignments
          </Button>
        </div>
      </div>
    );
  }
}

export default AssignmentsSelect;
